"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.match");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _validate = require("@/utils/validate");

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "organization:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['checkOptions', 'costStatusOption', 'netwayCodeOption', 'balanceProcessingOption', 'authenticateOptions', 'statusOptions', 'useOptions', 'informationOptions']), {
    showCallerInput: function showCallerInput() {
      return process.env.VUE_APP_SHOW_CALLER_INPUT === '1';
    },
    textMap: function textMap() {
      return {
        update: _lang.default.t("common.update"),
        create: _lang.default.t("common.addNew"),
        recharge: _lang.default.t("common.recharge"),
        invalid: _lang.default.t("common.invalid"),
        cost: _lang.default.t("common.cost")
      };
    },
    errorInfo: function errorInfo() {
      return {
        emptyAgentName: this.$t('SMS.username') + this.$t('SMS.canNotBeEmpty'),
        invalidAccountNameLength: this.$t('message.message72'),
        invalidAccountName: this.$t('message.message74'),
        emptyPassword: this.$t('SMS.password') + this.$t('SMS.canNotBeEmpty'),
        emptyPayPassword: this.$t('SMS.payPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyConfirmPassword: this.$t('SMS.confirmPassword') + this.$t('SMS.canNotBeEmpty'),
        invalidPayPasswordLength: this.$t('message.message73'),
        invalidPasswordLength: this.$t('message.organizationManagementMessage13'),
        invalidPasswordFormat: this.$t('warningMessage.passwordFormatNoUpperMessage'),
        organizationManagementMessage14: this.$t("message.organizationManagementMessage14")
      };
    },
    rules: function rules() {
      var _this = this;

      var checkPasswordFormat = function checkPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (_this.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this.errorInfo.emptyPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this.errorInfo.invalidPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      var checkAccountFormat = function checkAccountFormat(rule, value, callback) {
        var length;
        var minlength = 6;
        var maxlength = 20;

        if (_this.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this.errorInfo.emptyAgentName));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this.errorInfo.invalidAccountNameLength));
        }

        if (/.*[\u4e00-\u9fa5|\！|\，|\。|\（|\）|\《|\》|\“|\”|\？|\：|\；|\【|\】]+.*/.test(value)) {
          return callback(new Error(_this.errorInfo.invalidAccountName));
        } else {
          return callback();
        }
      };

      var checkPassword = function checkPassword(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this.errorInfo.emptyConfirmPassword));
        }

        if (_this.formTemp.userPassword !== value) {
          return callback(new Error(_this.errorInfo.organizationManagementMessage14));
        }

        return callback();
      };

      var checkPayPasswordFormat = function checkPayPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (_this.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this.errorInfo.emptyPayPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this.errorInfo.invalidPayPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      return {
        agentId: [{
          required: true,
          message: _lang.default.t("SMS.agentId") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        organizationName: [{
          required: true,
          message: _lang.default.t("SMS.organizationName") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        organizationCode: [{
          required: true,
          message: _lang.default.t("SMS.organizationCode") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        userAccount: [{
          required: true,
          validator: checkAccountFormat,
          trigger: "blur"
        }],
        userPassword: [{
          required: true,
          validator: checkPasswordFormat,
          trigger: "blur"
        }],
        checkPassword: [{
          required: true,
          validator: checkPassword,
          trigger: "blur"
        }],
        payPassword: [{
          required: true,
          validator: checkPayPasswordFormat,
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: _lang.default.t("SMS.status") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }] // email:[
        //   {
        //   validator: this.checkChinese,
        //   message: i18n.t("message.message75"),
        //   trigger: "blur",
        // },]

      };
    }
  }),
  data: function data() {
    return {
      hasGoogleKey: true,
      dialogFormVisible: false,
      dialogInvalidVisible: false,
      // dialogCostVisible: false,
      copyCostDialogVisible: false,
      changeAgentDialogVisible: false,
      orgDetailDialogVisible: false,
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      formLoading: false,
      time: null,
      channelList: null,
      dialogType: "",
      agentOption: [],
      orgApproveStateOption: null,
      merchantKidForProduct: 0,
      costOrganizationCode: "",
      isDisabled: false,
      organizationNameOption: null,
      timeList: [new Date(Date.now()), new Date(Date.now())],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        agentId: "",
        organizationCode: "",
        organizationName: "",
        description: "",
        status: "",
        approveStateCode: ""
      },
      copyCostParameter: {
        sourceOrganizationCode: "",
        targetOrganizationCode: []
      },
      changeAgentParameter: {
        originAgentId: "",
        targetOrganizationCodes: [],
        targetAgentId: ""
      },
      orgDetail: {
        HTTPDetail: {
          orgCode: null,
          md5Key: null,
          httpApi: null,
          httpApiDocLink: null
        },
        SMPPDetail: {
          orgCode: null,
          md5Key: null,
          systemId: null,
          password: null,
          channelLine: null,
          channelLimit: null,
          smppApi: null
        }
      },
      invalidRules: {
        orgAmountHandle: [{
          required: true,
          message: _lang.default.t("SMS.balanceProcessing") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      rechargeRules: {
        netwayCode: [{
          required: true,
          message: _lang.default.t("SMS.netwayCode") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        processRechargeAmount: [{
          required: true,
          message: _lang.default.t("SMS.rechargeAmount") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        verifyCode: [{
          required: true,
          message: _lang.default.t("SMS.verificationCode") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        payPassword: [{
          required: true,
          message: _lang.default.t("SMS.payPassword") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      formTemp: {},
      invalidTemp: {},
      key: 1,
      oldestDate: null,
      multipleSelection: []
    };
  },
  created: function created() {
    if (this.$store.getters.isAgent) {
      this.checkGoogleKeyInAgent();
    }

    this.getAgent();
    this.setDefaultTime();
    this.getOrgs();
    this.getList();
  },
  methods: {
    setDefaultTime: function setDefaultTime() {
      var date = new Date(),
          y = date.getFullYear(),
          m = date.getMonth(),
          d = date.getDate(),
          h = date.getHours(),
          min = date.getMinutes(),
          sec = date.getSeconds();
      var startTime = new Date(y, m, d - 3, h, min, sec - 1);
      var endTime = new Date(y, m, d, h, min, sec - 1); // startTime.setHours(0, 0, 0, 0);
      // endTime.setHours(23, 59, 59, 0);

      this.timeList = [startTime, endTime];
      this.oldestDate = new Date(y, m, d - 7, h, min, sec - 1);
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getOrgs: function getOrgs() {
      var _this2 = this;

      _httpUtils.default.post("organization", "getOrgs", null, null).then(function (res) {
        _this2.organizationNameOption = res.data;
        setTimeout(function () {
          _this2.listLoading = false;
        }, 1 * 1000);
      }).catch(function (error) {
        _this2.$message({
          message: error.message,
          type: 'error'
        });
      });
    },
    convertStatusName: function convertStatusName(name) {
      var found = "";
      this.statusOptions.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertAuthenticateName: function convertAuthenticateName(name) {
      var found = "";
      this.authenticateOptions.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    checkGoogleKeyInAgent: function checkGoogleKeyInAgent() {
      var _this3 = this;

      // httpUtils.get("HomeData", "getIndexInAgent", null).then((agent) => {
      _httpUtils.default.post("agentUser", "existQrCode", null).then(function (agent) {
        if (agent.data === false) {
          _this3.hasGoogleKey = false;
        }
      }).catch(function (err) {
        _this3.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    getAgent: function getAgent() {
      var _this4 = this;

      _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
        _this4.agentOption = agent.data;
      }).catch(function (err) {
        _this4.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    getList: function getList() {
      var _this5 = this;

      if (!this.hasViewPermission) {
        return;
      }

      ;
      this.listLoading = true;

      _httpUtils.default.post("organization", "list", null, this.listQuery).then(function (res) {
        var index = 0;
        _this5.list = res.data.rows;
        _this5.total = res.data.total;

        for (index = 0; index < _this5.list.length; index++) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = _this5.agentOption[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var agentData = _step.value;

              if (agentData.agentId === _this5.list[index].agentId) {
                _this5.list[index].agentName = agentData.agentName;
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        setTimeout(function () {
          _this5.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this5.listLoading = true;

        _this5.$message({
          type: "error",
          message: err.message
        });
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList();
    },
    resetFormTemp: function resetFormTemp() {
      var _this6 = this;

      this.formTemp = {
        id: "",
        agentId: "",
        agentName: "",
        organizationCode: "",
        organizationName: "",
        userAccount: "",
        userPassword: "",
        checkPassword: "",
        contact: "",
        contactMobile: "",
        smsApproveType: "",
        status: "",
        email: "",
        address: "",
        webUrl: "",
        bindIp: "",
        description: ""
      };
      this.$nextTick(function () {
        return _this6.$refs["dataForm"].clearValidate();
      });
    },
    resetInvalidTemp: function resetInvalidTemp() {
      this.invalidTemp = {
        id: "",
        agentId: "",
        agentName: "",
        contact: "",
        contactMobile: "",
        smsApproveType: "",
        bindIp: "",
        description: "",
        organizationCode: "",
        organizationName: "",
        processAvailableAmount: "",
        orgAmountHandle: "0"
      };
    },
    getRowDataForInvalid: function getRowDataForInvalid(row) {
      this.invalidTemp = {
        id: row.id,
        agentId: row.agentId,
        agentName: row.agentName,
        contactMobile: row.contactMobile,
        smsApproveType: row.smsApproveType,
        bindIp: row.bindIp,
        description: row.description,
        organizationCode: row.organizationCode,
        organizationName: row.organizationName,
        processAvailableAmount: row.processAvailableAmount,
        orgAmountHandle: "0"
      };
    },
    handleCreate: function handleCreate() {
      this.resetFormTemp();
      this.formTemp.smsApproveType = "0";
      this.dialogType = "create";
      this.dialogFormVisible = true;
    },
    handleInvalid: function handleInvalid(row) {
      var _this7 = this;

      this.resetInvalidTemp();
      this.getRowDataForInvalid(row);
      this.dialogType = "invalid";
      this.$nextTick(function (_) {
        _this7.dialogInvalidVisible = true;
      });
    },
    handleCost: function handleCost(row) {
      this.$router.push({
        name: "organizationCost:view",
        params: {
          organizationCode: row.organizationCode
        }
      });
    },
    getRowData: function getRowData(row) {
      this.formTemp = {
        id: row.id,
        agentId: row.agentId,
        agentName: row.agentName,
        organizationCode: row.organizationCode,
        organizationName: row.organizationName,
        contactMobile: row.contactMobile,
        smsApproveType: row.smsApproveType,
        status: row.status,
        contact: row.contact,
        email: row.email,
        address: row.address,
        webUrl: row.webUrl,
        bindIp: row.bindIp,
        description: row.description
      };
    },
    handleUpdate: function handleUpdate(row) {
      this.resetFormTemp();
      this.getRowData(row);
      this.dialogType = "update";
      this.dialogFormVisible = true;
    },
    handleDelete: function handleDelete(state) {
      var _this8 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "delete") {
        message = _lang.default.t("warningMessage.batchCancelOrganizationConfirmMessage") + "<br />" + "<b>" + _lang.default.t("warningMessage.batchCancelOrganizationConfirmRemarkMessage") + "</b>" + "<br />" + _lang.default.t("warningMessage.cancelOrganizationRemarkMessage") + "<br />" + _lang.default.t("warningMessage.cancelOrganizationRemarkMessage1");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this8.doDeleteData();
      }).catch(function () {
        _this8.$message({
          type: "info",
          message: _lang.default.t("warningMessage.cancelOrganizationCancelledMessage")
        });
      });
    },
    handleApproveSuccess: function handleApproveSuccess(state) {
      var _this9 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "approve") {
        message = _lang.default.t("message.message21");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this9.doApproveSuccessData();
      }).catch(function () {
        _this9.$message({
          type: "info",
          message: _lang.default.t("message.message25")
        });
      });
    },
    handleApproveFail: function handleApproveFail(state) {
      var _this10 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "reject") {
        message = _lang.default.t("message.message22");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this10.doApproveFailData();
      }).catch(function () {
        _this10.$message({
          type: "info",
          message: _lang.default.t("message.message23")
        });
      });
    },
    doDeleteData: function doDeleteData() {
      var _this11 = this;

      var ids = [];

      for (var data in this.multipleSelection) {
        ids.push(this.multipleSelection[data].id);
      }

      this.listLoading = true;

      _httpUtils.default.post("organization", "batchCancel", null, ids).then(function (res) {
        if (res.code === 200) {
          _this11.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("warningMessage.cancelOrganizationSuccessMessage"),
            type: "success",
            duration: 2000
          });

          _this11.listQuery.pageNum = _this11.listQuery.pageNum;
          _this11.listQuery.pageSize = 10;

          _this11.resetFormTemp();

          _this11.getList();
        } else {
          _this11.$message({
            showClose: true,
            message: _lang.default.t("message.message5"),
            type: "warning"
          });
        }
      }).catch(function (err) {
        _this11.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    doInvalidData: function doInvalidData() {
      var _this12 = this;

      this.$refs["dataInvalid"].validate(function (valid) {
        if (valid) {
          _httpUtils.default.post("organization", "cancel", null, _this12.invalidTemp).then(function (res) {
            if (res.code === 200) {
              _this12.$notify({
                title: _lang.default.t("message.organizationManagementMessage19"),
                type: "success",
                duration: 2000
              });

              _this12.dialogInvalidVisible = false;
              setTimeout(function () {
                _this12.resetFormTemp();

                _this12.resetInvalidTemp();

                _this12.getList();
              }, 1.5 * 1000);
            }
          }).catch(function (err) {
            _this12.$message({
              showClose: true,
              message: _lang.default.t("message.organizationManagementMessage24") + err.message,
              type: "warning"
            });
          });
        }
      });
    },
    doCreateData: function doCreateData() {
      var _this13 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this13.formLoading = true;

          _httpUtils.default.post("organization", "add", null, _this13.formTemp).then(function (res) {
            if (res.code === 200) {
              _this13.$notify({
                title: _lang.default.t("message.message6"),
                message: res.data,
                type: "success",
                duration: 2000
              });

              _this13.dialogFormVisible = false;
              setTimeout(function () {
                _this13.resetFormTemp();

                _this13.getList();

                _this13.formLoading = false;
              }, 1 * 1000);
            }
          }).catch(function (err) {
            _this13.$message({
              message: err.message,
              type: 'error'
            });

            _this13.formLoading = false;
          });
        }
      });
    },
    doUpdateData: function doUpdateData() {
      var _this14 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this14.formLoading = true;

          _httpUtils.default.post("organization", "update", null, _this14.formTemp).then(function (res) {
            if (res.code === 200) {
              _this14.$notify({
                title: _lang.default.t("SMS.success"),
                message: _lang.default.t("message.message41"),
                type: "success",
                duration: 2000
              });

              _this14.dialogFormVisible = false;
              setTimeout(function () {
                _this14.resetFormTemp();

                _this14.getList();

                _this14.formLoading = false;
              }, 1 * 1000);
            }
          }).catch(function (e) {
            _this14.formLoading = false;

            _this14.$notify({
              title: _lang.default.t("SMS.alarm"),
              message: _lang.default.t("message.message42") + ',' + e.message,
              type: "warning",
              duration: 2000
            });
          });
        }
      });
    },
    doApproveSuccessData: function doApproveSuccessData() {
      var _this15 = this;

      var ids = [];

      for (var data in this.multipleSelection) {
        ids.push(this.multipleSelection[data].id);
      }

      _httpUtils.default.post("organization", "approveSuccessOrgs", null, ids).then(function (res) {
        if (res.code === 200) {
          _this15.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("message.message9"),
            type: "success",
            duration: 2000
          });

          _this15.resetFormTemp();

          _this15.getList();
        } else {
          _this15.$message({
            showClose: true,
            message: _lang.default.t("message.message10"),
            type: "warning"
          });
        }
      }).catch(function (err) {
        _this15.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    doApproveFailData: function doApproveFailData() {
      var _this16 = this;

      var ids = [];

      for (var data in this.multipleSelection) {
        ids.push(this.multipleSelection[data].id);
      }

      _httpUtils.default.post("organization", "approveFailOrgs", null, ids).then(function (res) {
        if (res.code === 200) {
          _this16.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("message.message11"),
            type: "success",
            duration: 2000
          });

          _this16.resetFormTemp();

          _this16.getList();
        } else {
          _this16.$message({
            showClose: true,
            message: _lang.default.t("message.message12"),
            type: "warning"
          });
        }
      }).catch(function (err) {
        _this16.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    checkSelection: function checkSelection() {
      var message, info;

      if (this.multipleSelection === undefined ? true : this.multipleSelection.length === 0) {
        message = _lang.default.t("message.message16");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return true;
      }
    },
    isMobile: function isMobile(rule, value, callback) {
      var reg = /^1[3456789]\d{9}$/;

      if (!reg.test(parseInt(value))) {
        return callback(new Error());
      }

      return callback();
    },
    handleCopyCost: function handleCopyCost() {
      var _this17 = this;

      if (this.copyCostParameter.sourceOrganizationCode === '' || this.copyCostParameter.sourceOrganizationCode === null || this.copyCostParameter.targetOrganizationCode === null || this.copyCostParameter.targetOrganizationCode.length == 0) {
        this.$message({
          message: _lang.default.t('warningMessage.pleaseSelectSourceOrganizationAndTargetOrganizationMessage'),
          type: 'error'
        });
      } else {
        _httpUtils.default.post("organizationCost", "copyCost", null, this.copyCostParameter).then(function (res) {
          if (res.code === 200) {
            _this17.$notify({
              title: _lang.default.t("SMS.success"),
              message: _lang.default.t("warningMessage.copyOrganizationCostSuccessMessage"),
              type: "success",
              duration: 2000
            });

            _this17.handleResetCopyCost();
          } else {
            _this17.$message({
              showClose: true,
              message: res.message,
              type: "warning"
            });
          }
        }).catch(function (err) {
          _this17.$message({
            message: err.message,
            type: 'error'
          });
        });
      }
    },
    handleResetCopyCost: function handleResetCopyCost() {
      this.copyCostDialogVisible = false;
      this.copyCostParameter.sourceOrganizationCode = "";
      this.copyCostParameter.targetOrganizationCode = [];
    },
    handleResetChangeAgent: function handleResetChangeAgent() {
      this.changeAgentDialogVisible = false;
      this.changeAgentParameter.targetOrganizationCodes = [];
      this.changeAgentParameter.targetAgentId = "";
    },
    handleExportActiveUserReport: function handleExportActiveUserReport() {
      var params = this.listQuery;
      var invalidDate = Date.parse(this.timeList[0]) <= this.oldestDate.getTime();

      if (invalidDate) {
        this.$notify({
          message: this.$t("warningMessage.pleaseSelectLatestSevenDaysMessage"),
          type: "info"
        });
      } else {
        params.beginDate = this.dateFormat(this.timeList[0]);
        params.endDate = this.dateFormat(this.timeList[1]);

        var excelName = _lang.default.t("SMS.activeUserExcelText");

        _httpUtils.default.getByBlob("organization", "exportActiveUserExcel", params, excelName);

        this.$message({
          message: _lang.default.t("warningMessage.pleaseWaitForExportMessage"),
          type: "info",
          showClose: true
        });
      }
    },
    checkChangeAgent: function checkChangeAgent() {
      this.changeAgentDialogVisible = true;
    },
    handleChangeAgent: function handleChangeAgent() {
      var _this18 = this;

      if (this.changeAgentParameter.targetAgentId === '' || this.changeAgentParameter.targetAgentId === null || this.changeAgentParameter.targetOrganizationCodes === null || this.changeAgentParameter.targetOrganizationCodes.length == 0) {
        this.$message({
          message: _lang.default.t('warningMessage.pleaseSelectTargetOrganizationAndTargetAgentMessage'),
          type: 'error'
        });
      } else {
        _httpUtils.default.post("organization", "changeAgentOfOrganization", null, this.changeAgentParameter).then(function (res) {
          if (res.code === 200) {
            _this18.$notify({
              title: _lang.default.t("SMS.success"),
              message: _lang.default.t("warningMessage.changeAgentSuccessMessage"),
              type: "success",
              duration: 2000
            });

            _this18.handleResetChangeAgent();

            _this18.getList();
          } else {
            _this18.$message({
              showClose: true,
              message: res.message,
              type: "warning"
            });
          }
        }).catch(function (err) {
          _this18.$message({
            message: err.message,
            type: 'error'
          });
        });
      }
    },
    convertAgentNameByAgentId: function convertAgentNameByAgentId(id) {
      if (!this.agentOption || !this.agentOption.length) return;
      var found = this.agentOption.find(function (agent) {
        return agent.agentId === id;
      });

      if (found) {
        return found.agentName;
      } else {
        return id;
      }
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    downloadApiDetail: function downloadApiDetail(row) {
      var txtName = row.organizationName + _lang.default.t("organization.viewOrgDetailText") + '.txt';

      _httpUtils.default.getByBlobForTxt("organization", "exportOrganizationApiDetail", row.organizationCode, txtName);

      this.$message({
        message: _lang.default.t("exportedExcel.downloadText"),
        type: "info",
        showClose: true
      });
    }
  }
};
exports.default = _default;